import React, { useEffect, useState } from 'react';
import { useParams, Link } from "react-router-dom";

export default function ZoneDetails() {
  const { name } = useParams();
  const [zone, setZone] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://api.nxtrp.pl/api/zone/${encodeURIComponent(name)}`)
      .then(res => res.json())
      .then(data => {
        setZone(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [name]);

  if (loading) return <div>Ładowanie…</div>;
  if (!zone || zone.error) return <div>Nie znaleziono strefy!</div>;

  // Obsługa przypadku gdy owner nie istnieje lub ma name "Brak"
  const hasOwner = zone.owner && zone.owner.name && zone.owner.name !== "Brak";

  return (
    <div>
      <h2>Strefa: {zone.name}</h2>
      <div className="gang-info-row">
        <strong>Aktualnie kontroluje:</strong>
        <span
          className="gang-avatar"
          style={{ background: hasOwner ? zone.owner.color : "#888" }}
          title={hasOwner ? zone.owner.name : "Brak właściciela"}
        >
          {hasOwner ? zone.owner.name[0] : "?"}
        </span>
        <span>{hasOwner ? zone.owner.name : "Brak właściciela"}</span>
      </div>
      <div>
        <strong>Ostatnie przejęcie:</strong> {zone.lastCapture ? zone.lastCapture : "-"}
      </div>
        <div>
          <strong>Historia przejęć tej strefy:</strong>
          <ul>
            {zone.captures && zone.captures.length ? zone.captures.map((c, i) => (
              <li key={i} className={c.success === 1 ? "success-capture" : "fail-capture"}>
                {c.at} — {c.by} {c.success === 1 ? "✔️" : "❌"}
              </li>
            )) : <li>Brak danych</li>}
          </ul>
        </div>
      <Link to="/" className="back-btn">
        <span aria-hidden="true" style={{marginRight: 6}}>←</span>
        Wróć do listy
      </Link>
    </div>
  );
}
